import React, {useEffect, useState} from "react";
import EnigooBreadcrumbs from "../../components/breadcrumbs/EnigooBreadcrumbs";
import {apiGetConfig, apiGetSendTestMail, apiPutConfig} from "./Actions";
import {useNavigate} from "react-router-dom";
import {Form} from "react-final-form";
import {FiPlus, FiSave} from "react-icons/fi";
import {Button} from "../../components/My/Button";
import CogoToast from "cogo-toast";
import {DefaultLoader} from "../../components/DefaultLoader";
import RadioField from "../../components/FinalForm/RadioField";
import SelectField from "../../components/FinalForm/SelectField";
import Toast from "cogo-toast";
import {IconTabs} from "../../components/tabs";
import {useSelector} from "react-redux";
import InputField from "../../components/FinalForm/InputField";
import {apiPostAction} from "../Action/Actions";

const Config = () => {

    const navigate = useNavigate();
    const {user} = useSelector((state) => state);
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        apiGetConfig((data) => {
            setData(data);
            setLoading(false);
        }, (err) => {
            navigate("/account/exhibit");
            setLoading(false);
        })
    }, [])

    const onSubmit = (values) => {
        setLoading(true);
        apiPutConfig((result) => {
            setData(result);
            setLoading(false);
            CogoToast.success("Uloženo.");
        }, (err) => {
            setLoading(false);
            CogoToast.error("Nepodařilo se uložit.");
        }, values);
    }

    const onMailSend = (values) => {
        setLoading(true);
        apiGetSendTestMail(values.type, (result) => {
            Toast.success("Email odeslán");
            setLoading(false);
        }, (err) => {
            Toast.error("Nepodařilo se odeslat email.")
            setLoading(false);
        })
    }

    const onNewActionCreate = (values) => {
        setLoading(true);
        apiPostAction(values,(result) => {
            Toast.success("Nový ročník vytvořen")
            setLoading(false);
            window.location.reload();
        },(err) => {
            switch (err.type){
                case "ACTION_NAME_ALREADY_EXIST":
                    Toast.error("Název ročníku již existuje.");
                    break;
                default:
                    Toast.error("Nepodařilo se vytvořit nový ročník.")
            }
            setLoading(false);
        })
    }

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám konfiguraci..."}/>
        return <>
            <div className="w-full flex justify-center bg-grey-50">
                <Form onSubmit={onSubmit} initialValues={data}
                      render={({handleSubmit, values, ...props}) => {
                          return (
                              <div
                                  className={"flex flex-col space-y-2 w-full bg-white border border-grey-200 lg:p-8 sm:p-2 mb-2"}>
                                  <div
                                      className={`grid grid-cols-2 gap-2 w-full sm:max-w-full  text-base`}>
                                      <div className={"form-element lg:mt-1"}>
                                          <div className="form-label font-bold">
                                              Registrace povoleny: <sup className={"text-legendyColor"}>*</sup>
                                          </div>

                                          <div className="lg:w-1/2 w-full flex flex-row">
                                              <div className={"flex flex-col"}>
                                                  <RadioField name={"registerEnable"} label={"ANO"}
                                                              id={"config-disablereg" + 0}
                                                              value={"1"}
                                                              defaultChecked={data && data.registerEnable === "1"}
                                                              group={"registerDis"} isMandatory={true}/>
                                              </div>
                                              <div className={"flex flex-col"}>
                                                  <RadioField name={"registerEnable"} label={"NE"}
                                                              id={"config-disablereg" + 1}
                                                              value={"0"}
                                                              defaultChecked={data && data.registerEnable === "0"}
                                                              group={"registerDis"} isMandatory={true}/>
                                              </div>
                                          </div>
                                      </div>
                                      <InputField name={"registerDisableMessage"} label={"Hláška při vypnutých registracích"} isMandatory={false}/>

                                      <div className={"form-element lg:mt-1"}>
                                          <div className="form-label font-bold">
                                              Přihlášení pouze pro ředitele: <sup
                                              className={"text-legendyColor"}>*</sup>
                                          </div>

                                          <div className="lg:w-1/2 w-full flex flex-row">
                                              <div className={"flex flex-col"}>
                                                  <RadioField name={"onlyDirectorLogin"} label={"ANO"}
                                                              id={"config-onlyDirectorLogin" + 0}
                                                              value={"1"}
                                                              defaultChecked={data && data.onlyDirectorLogin === "1"}
                                                              group={"onlyDirectorLogin"} isMandatory={true}/>
                                              </div>
                                              <div className={"flex flex-col"}>
                                                  <RadioField name={"onlyDirectorLogin"} label={"NE"}
                                                              id={"config-onlyDirectorLogin" + 1}
                                                              value={"0"}
                                                              defaultChecked={data && data.onlyDirectorLogin === "0"}
                                                              group={"onlyDirectorLogin"} isMandatory={true}/>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <Button text={"Uložit"} icon={<FiSave/>} onClick={handleSubmit}/></div>
                          )
                      }}/>
            </div>

        </>
    }

    const _renderMailBody = () => {
        return <>
            <div className="w-full flex justify-center bg-grey-50">
                <Form onSubmit={onMailSend} initialValues={data}
                      render={({handleSubmit, values, ...props}) => {
                          return (
                              <div
                                  className={`flex flex-col space-y-2 bg-white border border-grey-200 lg:p-8 sm: p-2 w-full sm:max-w-full mb-2 text-base`}>
                                  <SelectField name={"type"} options={[
                                      {value: 1, label: "Email po nové registrace"},
                                      {value: 2, label: "Email po přihlášení exponátu do nové akce"},
                                      {value: 3, label: "Email po schválení exponátu"},
                                      {value: 4, label: "Email po neschválení exponátu"},

                                  ]} label={"Odeslat testovací email"} isMandatory={true}/>

                                  <Button text={"Odeslat"} icon={<FiSave/>} onClick={handleSubmit}/>

                              </div>
                          )
                      }}/>
            </div>

        </>
    }

    const _renderNewActionForm = () => {
        return <>
            <div className="w-full flex justify-center bg-grey-50">
                <Form onSubmit={onNewActionCreate}
                      render={({handleSubmit, values, ...props}) => {
                          return (
                              <div
                                  className={`flex flex-col space-y-2 bg-white border border-grey-200 lg:p-8 sm: p-2 w-full sm:max-w-full mb-2 text-base`}>
                                  <InputField name={"name"} label={"Název"} isMandatory={true}/>

                                  <Button text={"Vytvořit"} icon={<FiSave/>} onClick={handleSubmit}/>

                              </div>
                          )
                      }}/>
            </div>

        </>
    }

    const getTabs = () => {
        let array = [{
            index: 0,
            title: "Nastavení registrací",
            content: _renderBody()
        },
            {
                index: 1,
                title: "Testování emailů",
                content: _renderMailBody()
            }
        ];

        if (user.user.enigoo_admin) {
            array.push({
                index: 2,
                title: "Nový ročník",
                content: _renderNewActionForm()
            })
        }


        return array;
    }

    return <>
        <EnigooBreadcrumbs/>
        <IconTabs tabs={getTabs()}/>
    </>
}
export default Config
